import { Component } from 'preact';
import { html } from '../../helpers/preact-html';

class DesktopNavigationPageL2 extends Component {
  renderHeading({ label }) {
    return html` <div class="label">${label}</div> `;
  }

  renderLink({ label, id, href, children, badge, highlight, newwindow }) {
    const {
      onSelectSubmenu,
      currentThirdLayerMenuItemId,
      currentMenuLayer,
    } = this.props;

    const wrapperClasses = ['navigation-page-item'];

    highlight && wrapperClasses.push('navigation-page-item-ishighlighted');
    currentMenuLayer === 3 &&
      currentThirdLayerMenuItemId === id &&
      wrapperClasses.push('navigation-page-item-isSelected');

    const onLinkClick =
      !href || href.length === 0
        ? (e) => {
            e.preventDefault();
            onSelectSubmenu(id);
          }
        : null;

    const target = href && newwindow ? '_blank' : null;

    return html`
      <div class=${wrapperClasses.join(' ')} key=${id}>
        <a
          class="link-nostyle"
          href=${href ? href : ''}
          onClick=${onLinkClick}
          target=${target}
        >
          <span>
            ${label}
            ${badge &&
            badge.length > 0 &&
            html`<span class="navigation-page-badge label">${badge}</span>`}
          </span>
        </a>
        ${children &&
        children.length &&
        html`
          <button
            type="button"
            class="button button-icon button-tertiary button-icon-mediumicon"
            aria-label="Navigiere zu '${label}'"
            data-trigger="nav"
            onClick=${() => onSelectSubmenu(id)}
          >
            <i class="ri-arrow-right-s-line" aria-label="Pfeil nach rechts"></i>
          </button>
        `}
      </div>
    `;
  }

  renderBackButton() {
    const { onNavigateToFirstLayer } = this.props;
    return html`
      <button
        class="navigation-page-backbutton"
        onClick=${onNavigateToFirstLayer}
      >
        <i class="ri-arrow-left-line" aria-hidden="true"></i>
        <div>Bereich / Schulform ändern</div>
      </button>
    `;
  }

  render({ navPage, firstLayerMenu }) {
    return html`
      <div class="navigation-page">
        <div class="label navigation-page-label navigation-page-label"
          >${firstLayerMenu.label} /</div
        >
        <h3>${navPage.label}</h3>
        ${this.renderBackButton()}
        ${navPage.children.map((child) =>
          child.type === 'heading'
            ? this.renderHeading(child)
            : this.renderLink(child),
        )}
      </div>
    `;
  }
}

export { DesktopNavigationPageL2 };
